module.exports = __webpack_public_path__ + "img/zhuti.02b6dd3a.png";